import { createFileRoute, redirect } from '@tanstack/react-router';

import { VerifyEmailPage } from '@/pages/auth/verify-email';

type VerifyEmailSearch = {
  email?: string;
  token?: string;
};
export const Route = createFileRoute('/(auth)/verify-email')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated && context.auth.user?.is_email_verified) {
      throw redirect({ to: '/courses' });
    }
  },
  validateSearch: (search: Record<string, string>): VerifyEmailSearch => {
    return {
      email: search.email ? search.email : undefined,
      token: search.token ? search.token : undefined,
    };
  },
  component: VerifyEmailPage,
});
